import {RoomProtocolMapperClient} from './RoomProtocolMapperClient.ts'
import {TranslationObject} from '@colonist/i18n'
import {UIPopupController} from './ui_popup/UIPopupController.ts'
import {notificationController} from './EntryShared.ts'
import {LobbyImage, SharedStrings} from '@colonist/types'
import {UITopNotificationType} from './notifications/UINotificationController.ts'

export function registerSharedRoomClientHandlers(roomClient: RoomProtocolMapperClient) {
    roomClient.onInvalidPlayerCountEncountered((playerCount, missingExtension) => {
        const popupTitle: TranslationObject = {key: 'strings:popups.informationView.title'}
        const popupBody: TranslationObject = {
            key: missingExtension ? 'strings:roomPage.notifications.failedToSelectPlayerCount' : 'strings:roomPage.notifications.invalidGameModeSelected',
            options: {
                playerCount: playerCount,
            },
        }
        UIPopupController.createSimplePopup(popupTitle, popupBody)
    })

    roomClient.onFailedToReducePlayerCount(() => {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.kickPlayersBeforeMakingRoomSmaller'})
    })

    roomClient.onFailedToStartGameBecauseServerIsUpdating(() => {
        notificationController.show({
            key: 'strings:colonistCommon.serverStatus.serverUpdating',
            options: {
                discordLink: SharedStrings.DISCORD_CHANNEL,
            },
        }, UITopNotificationType.Information)
    })

    roomClient.onFailedToStartGamePlayersNotReady((players) => {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.usersNotReadyToPlay', options: {usernames: players, count: players.length}})
    })

    roomClient.onFailedToSelectUsedColor(() => {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.colorNotAvailable'})
    })

    roomClient.onFailedToExecuteCommandGameStarting(() => {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.gameStarting'})
    })

    roomClient.onFailedToSetGameSpeed(() => {
        notificationController.showNotification(LobbyImage.Lightning, {key: 'strings:roomPage.notifications.failedToSetGameSpeed'})
    })
}
